import React, { useEffect, useLayoutEffect, useState } from "react";
import { useAuth } from "../../../../modules/auth";
import DetallesTestimonio from "../../../Testimonial/EntrevistaIndividual/detallesTestimonio";
import AudioPlayer from "./audioplayer";
import { IFile, ITestimonio, createTestimonio } from "./testimonioModel";
import { useParams } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL
const auth = JSON.parse(localStorage.getItem("kt-auth-react-v")!);

interface Props {
  id : string | undefined;
}

const ReproductorTestimonio : React.FC<Props> = () => {
  const { id } = useParams<{ id: string }>(); 
  const [testimonio, setTestimonio] = useState<ITestimonio>();
  const [token, setToken] = useState<any | null>(null);  // Estado para almacenar el token

  useEffect(() => {  
    const storedToken = localStorage.getItem("kt-auth-react-v");
    if (storedToken) {
      setToken(JSON.parse(storedToken));  // Parse y setea el token al estado
    }
  }, []);

  useEffect(() => {
    if(id && token)
      getTestimonio(id);

  }, [id, token]);

  const getTestimonio = async (id: string): Promise<void> => {
    try {
      const response = await axios.post(`${API_URL}/files/getById`,  // URL de la API
        { id: id },  // Datos enviados en el cuerpo de la solicitud
        {
          headers: {
            'Content-Type': 'application/json',
            'auth-token': token.api_token  // Token JWT enviado en los headers
          }
        }
      );
      const newTestimonio = createTestimonio(response.data);
      setTestimonio(newTestimonio);
    } catch (error) {
      console.error('Error al obtener las personas:', error);
    }
  };

  return ( 
    <>
    {testimonio ? (
      <>
        <AudioPlayer id={testimonio._id} file={testimonio.files.find(files => files.categoria === 'Entrevista')!}></AudioPlayer>        
      </>
    ): (<></>)}
    </>
  )
}

export default ReproductorTestimonio;